import './index.scss';
var DEFAULT_OFFSET = 0;
var PAGE_CONTENT_SELECTOR = null;

function shouldControlHeight(element) {
  return !element.hasAttribute('data-scrollsnap-autoheight');
}

function shouldControlHeightFiller(element) {
  return shouldControlHeight(element) || element.hasAttribute('data-scrollsnap-autoheight-filler');
}

function activateScrollsnap(element) {
  var documentOffset = window.pageYOffset || document.documentElement.scrollTop;
  var elementBound = element.getBoundingClientRect();
  element.setAttribute('data-scrollsnap-active-offset', elementBound.top + documentOffset);

  if (shouldControlHeight(element)) {
    element.style.width = "".concat(elementBound.width, "px");
    element.style.height = "".concat(elementBound.height, "px");
  }

  if (shouldControlHeightFiller(element)) {
    if (!element.nextSibling || !element.nextSibling.classList.contains('scrollsnap__filler')) {
      var _filler = document.createElement('div');

      _filler.classList.add('scrollsnap__filler');

      element.parentNode.insertBefore(_filler, element.nextSibling);
    }

    var filler = element.nextSibling;
    filler.classList.add('scrollsnap__filler--active');
    filler.style.height = "".concat(elementBound.height, "px");
  }

  element.classList.add('scrollsnap--active');
}

function deactivateScrollsnap(element) {
  element.style.width = '';
  element.style.height = '';
  element.style.top = '';
  element.classList.remove('scrollsnap--active');

  if (shouldControlHeightFiller(element)) {
    element.nextElementSibling.classList.remove('scrollsnap__filler--active');
  }
}

function updateScrollSnap() {
  var documentOffset = window.pageYOffset || document.documentElement.scrollTop; // Calculate Content Bottom

  var pageContentBottom;

  if (PAGE_CONTENT_SELECTOR !== null) {
    var pageContent = document.querySelector(PAGE_CONTENT_SELECTOR);
    pageContentBottom = pageContent.offsetTop + pageContent.offsetHeight;
  } else {
    pageContentBottom = document.body.scrollHeight;
  } // Get Snap Elements


  document.querySelectorAll('[data-scrollsnap]').forEach(function (element) {
    var active = element.classList.contains('scrollsnap--active');

    if (element.offsetParent === null && !active) {
      return;
    }

    var topOffset;

    if (element.hasAttribute('data-scrollsnap-offset')) {
      topOffset = element.getIntegerAttribute('data-scrollsnap-offset');
    } else {
      topOffset = DEFAULT_OFFSET;
    }

    var contentBottom;

    if (element.hasAttribute('data-scrollsnap-content-parent')) {
      var contentParent = element.closest(element.getAttribute('data-scrollsnap-content-parent'));
      contentBottom = contentParent.offsetTop + contentParent.offsetHeight;
    } else {
      contentBottom = pageContentBottom;
    }

    if (active) {
      var offset = element.getIntegerAttribute('data-scrollsnap-active-offset');

      if (offset === 0) {
        return;
      }

      if (documentOffset + topOffset <= offset) {
        deactivateScrollsnap(element);
      } else {
        var elementBottom = topOffset + element.getBoundingClientRect().height;
        var difference = documentOffset + elementBottom - contentBottom;

        if (difference >= 0) {
          element.style.top = "".concat(topOffset - difference, "px");
        } else {
          element.style.top = '';
        }
      }
    } else {
      var _offset = element.getBoundingClientRect().top;

      if (topOffset >= _offset) {
        activateScrollsnap(element);
      }
    }
  });
}

export default {
  start: function start() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof options.defaultOffset === 'number') {
      DEFAULT_OFFSET = options.defaultOffset;
    }

    if (typeof options.pageContentSelector === 'string') {
      PAGE_CONTENT_SELECTOR = options.pageContentSelector;
    }

    window.addEventListener('scroll', updateScrollSnap, {
      passive: true
    });
  },
  updateScrollSnap: updateScrollSnap
};